/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Container,
  Dropdown,
  Header,
  Grid,
  Icon,
  Label,
  Menu,
  Popup,
  Sidebar,
} from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Link } from 'react-router';
import Cookies from 'js-cookie';
import ReactGA from 'react-ga4';
import { withTranslation } from 'react-i18next';

import {
  SUPER_ADMIN, ADMIN, ADMIN_COMMUNITY,
  DEVELOPER_TEAM_LEADER,
} from '../constants/groups';
import { SHOWROOM, LOAN_TRACKER, LEADV2, MARKETPLACE, CREDIT_CONTROL, COMMISSION_TRACKER, ANALYTICS, EINVOICE } from '../constants/apps';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import config from '../../config';

import { extractBookQuery } from '../actions/bookQuery';
import { flashErrorMessage } from '../actions/flash';
import { serverRequestGet, serverRequestPost } from '../actions/fetchM';
import { fetchAddressSettings } from '../actions/addressSettings';
import { fetchAffiliateMappings } from '../actions/affiliateMappings';
import { fetchAppConfig } from '../actions/appConfig';
import { fetchBankCaseStates } from '../actions/bankCaseStates';
import { fetchBanks } from '../actions/banks';
import { fetchBobForms } from '../actions/bobForms';
import { fetchCancellationReasons } from '../actions/cancellationReasons';
import { fetchCompanyCurrencies, logoutAndRedirect } from '../actions/auth';
import { fetchCurrencySetting } from '../actions/currencySetting';
import { fetchCustomOptions } from '../actions/customOptions';
import { fetchFinanceSources } from '../actions/financeSources';
import { fetchGlobalSettings } from '../actions/globalSettings';
import { fetchHimsPostcodes } from '../actions/himsPostcodes';
import { fetchIdentityPresets } from '../actions/identityPresets';
import { fetchPhoneValidationPresets } from '../actions/phoneValidationPresets';
import { fetchProjectMappings } from '../actions/projectMappings';
import { fetchProjectOptions } from '../actions/projectOptions';
import { fetchProjectSpecifications } from '../actions/projectSpecifications';
import { fetchProjectUnitLayoutSpecifications } from '../actions/projectUnitLayoutSpecifications';
import { fetchProjectUnitSpecifications } from '../actions/projectUnitSpecifications';
import { fetchSalesChartTypes } from '../actions/salesChartTypes';
import { fetchTags } from '../actions/tags';
import { fetchTemplates } from '../actions/templates';

import AddBankerAnnouncement from '../components/Announcements/AddBankerAnnouncement';
import Flash from '../components/Flash';
import AppFooter from '../components/AppFooter';
import SidebarNav from '../components/Sidebar';
import ChangesPrompt from '../components/ChangesPrompt';
import NewLogo from '../components/NewLogo';
import AppMenu from '../components/AppMenu';
import DropdownMenu from '../components/DropdownMenu';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Timestamp from '../components/Timestamp';
import { isForeignCompany } from '../utils/companies';
import { cleanURL } from '../utils/url';
import { initializeDisplayLanguage } from '../utils/displayLanguage';
import { normalizeLanguage, readLanguagePreference } from '../utils/languagePreference';
import { isCountryVietnam } from '../constants/countries';

const isPRS = config.get('prs');
class BookApp extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        customerOwnedByDeveloperExecutive: PropTypes.bool,
        leadManagementIsEnabled: PropTypes.bool,
        leadManagementWebURL: PropTypes.string,
        himsIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      preferredName: PropTypes.string,
      company: PropTypes.shape({
        shortName: PropTypes.string,
        customLogoSrc: PropTypes.string,
        companyCurrency: PropTypes.oneOfType([
          PropTypes.array,
        ]),
        isHeadquarters: PropTypes.bool,
        isSuperAdmin: PropTypes.bool,
        countryCode: PropTypes.string,
      }),
      companyBranch: PropTypes.shape({
        shortName: PropTypes.string,
        isExternal: PropTypes.bool,
      }),
      companyApps: PropTypes.oneOfType([
        PropTypes.array,
      ]),
      language: PropTypes.string,
      isBranchLeaderSupervisor: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      groups: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
      })),
    }),
    t: PropTypes.func,
    i18n: PropTypes.shape({
      language: PropTypes.string,
    }),
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      notifications: [],
      notificationLoading: false,
      path: this.props.location.pathname || '',
      apps: [{
        appID: SHOWROOM,
        app: { shortName: 'Showroom' },
        hasAccess: true,
        order: 1,
      }],
      defaultCurrency: '',
      activeIndex: 0,
      isMobile: window.innerWidth < 768,
      popUpState: false,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    const { auth, appConfig } = this.props;
    this.initLanguage();
    const promises = [
      store.dispatch(fetchAppConfig())
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchBanks(false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchBankCaseStates(false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      isPRS && store.dispatch(fetchProjectOptions(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchProjectMappings(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchProjectSpecifications(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchProjectUnitLayoutSpecifications(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchProjectUnitSpecifications(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchTags('picture', false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchTemplates('print', false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchTemplates('spa_reminder', false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchTemplates('termination', false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchTemplates('saleschart', false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchSalesChartTypes(false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchCompanyCurrencies())
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchBobForms(false))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchGlobalSettings(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchAffiliateMappings(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(extractBookQuery()),
      store.dispatch(fetchCancellationReasons(true))
      .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchAddressSettings(true))
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchIdentityPresets())
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchFinanceSources())
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchPhoneValidationPresets())
        .catch(err => store.dispatch(flashErrorMessage(err))),
      store.dispatch(fetchCustomOptions())
        .catch(err => store.dispatch(flashErrorMessage(err))),
    ];
    if (auth && auth.company) {
      if (isForeignCompany(auth.company)) {
        promises.push(
          store.dispatch(fetchCurrencySetting())
            .catch(err => store.dispatch(flashErrorMessage(err))),
        );
      }
      if (appConfig && appConfig.data && appConfig.data.himsIsEnabled) {
        promises.push(
          store.dispatch(fetchHimsPostcodes(false)),
            // .catch(err => store.dispatch(flashErrorMessage(err))),
        );
      }
    }
    return Promise.all(promises)
      .then(() => {
        const { apps } = this.state;
        const companyCurrency = this.props.auth.company.companyCurrency || [];
        // set currency for display
        const defaultCurrency = this.getDefaultCurrencyDisplay(companyCurrency);
       // if (this.props.appConfig.data.leadManagementIsEnabled) {
        //   apps.unshift({
        //     appID: LEAD,
        //     webURL: this.props.appConfig.data.leadManagementWebURL,
        //     app: { shortName: 'Lead' },
        //     hasAccess: true,
        //     order: 3,
        //   });
        // }
        if (this.props.auth && this.props.auth.companyApps) {
          const loanTracker = this.props.auth.companyApps.find(ca => ca.appID === LOAN_TRACKER);
          if (loanTracker && config.get('loanTrackerURL')) {
            apps.unshift({
              appID: LOAN_TRACKER,
              webURL: config.get('loanTrackerURL'),
              app: { shortName: 'Loan Tracker' },
              hasAccess: loanTracker.hasAccess,
              order: 2,
            });
          }
          const leadv2 = this.props.auth.companyApps.find(ca => ca.appID === LEADV2);
          if (leadv2) {
            if ((leadv2.trialEndsAt && moment(leadv2.trialEndsAt).unix() > moment().unix()) || !leadv2.trialEndsAt) {
              apps.unshift({
                appID: LEADV2,
                webURL: leadv2.webURL,
                app: { shortName: 'CRM' },
                hasAccess: leadv2.hasAccess,
                order: 3,
                expiresText: leadv2.trialEndsAt && `${moment(leadv2.trialEndsAt).diff(moment(), 'days')} days free trial`,
              });
            }
          }
        }
        if (config.get('mpURL') && this.props.auth.companyBranch.isExternal && this.props.auth.companyApps && this.props.auth.companyApps.find(ca => ca.appID === MARKETPLACE)) {
          apps.unshift({
            appID: MARKETPLACE,
            webURL: config.get('mpURL'),
            app: { shortName: 'Marketplace' },
            hasAccess: true,
            order: 4,
          });
        }
        if (this.props.auth && this.props.auth.companyApps) {
          const creditControl = this.props.auth.companyApps.find(ca => ca.appID === CREDIT_CONTROL);
          if (creditControl) {
            if (((creditControl.trialEndsAt && moment(creditControl.trialEndsAt).unix() > moment().unix()) ||
              !creditControl.trialEndsAt) &&
              (this.props.auth && this.props.auth.companyBranch && !this.props.auth.companyBranch.isExternal)
            ) {
              apps.unshift({
                appID: CREDIT_CONTROL,
                webURL: creditControl.webURL,
                app: { shortName: 'Credit Control' },
                hasAccess: creditControl.hasAccess,
                order: 5,
                expiresText: creditControl.trialEndsAt && `${moment(creditControl.trialEndsAt).diff(moment(), 'days')} days free trial`,
              });
            }
          }
        }
        if (this.props.auth && this.props.auth.companyApps && (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin)) {
          const analyticsData = this.props.auth.companyApps.find(ca => ca.appID === ANALYTICS);
          if (analyticsData) {
            apps.unshift({
              appID: ANALYTICS,
              webURL: analyticsData.webURL,
              app: { shortName: 'Analytics' },
              hasAccess: analyticsData.hasAccess,
              order: 6,
            });
          }
        }
        if (this.props.auth && this.props.auth.companyApps) {
          const commissionTracker = this.props.auth.companyApps.find(ca => ca.appID === COMMISSION_TRACKER);
          if (commissionTracker) {
            apps.unshift({
              appID: COMMISSION_TRACKER,
              webURL: commissionTracker.webURL,
              app: { shortName: 'Commission' },
              hasAccess: commissionTracker.hasAccess,
              order: 7,
              expiresText: '',
            });
          }
        }
        if (this.props.auth && this.props.auth.companyApps) {
          const eInvoice = this.props.auth.companyApps.find(ca => ca.appID === EINVOICE);
          if (eInvoice) {
            apps.unshift({
              appID: EINVOICE,
              webURL: eInvoice.webURL,
              app: { shortName: 'e-Invoice' },
              hasAccess: eInvoice.hasAccess,
              order: 8,
              expiresText: '',
            });
          }
        }
        this.setState({
          apps,
          defaultCurrency,
        });
      });
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.path !== !nextProps.location.pathname) {
      this.closeMenu();
    }
  }
  componentWillUnmount() {
    this.languageUnmounted = true;
    window.removeEventListener('resize', this.handleResize);
  }
  onChangeCurrencyDropdown = (e, { value }) => {
    e.preventDefault();
    if (value !== this.state.defaultCurrency) {
      Cookies.set('currency', value, { expires: 30 });
      window.location.reload();
    }
  }
  getDefaultCurrencyDisplay(companyCurrency = []) {
    // Set default currency from cookies if exist
    // else use company default and set cookies
    let cookieCurrency = Cookies.get('currency');
    if (!cookieCurrency) {
      const { code = null } = companyCurrency.find(c => c.isDefault) || {};
      if (!code) {
        // company currency is not set, returns null, currency dropdown will not be display
        return code;
      }
      cookieCurrency = code;
      Cookies.set('currency', cookieCurrency, { expires: 30 });
    }
    return cookieCurrency;
  }
  getCurrencyOptions() {
    const { activeIndex } = this.state;
    let currencies = this.props.auth.company.companyCurrency;
    if (!currencies) currencies = [];
    return currencies.map((c, i) => (
      activeIndex === 1 ? (
        <Menu.Item className="sub" name="user" key={i} value={c.code} onClick={this.onChangeCurrencyDropdown}>
          <Accordion.Content active={activeIndex === 1}>
            <Icon
              name="dollar"
              style={{ marginLeft: '1rem' }}
            />
            {c.code}
          </Accordion.Content>
        </Menu.Item>
      ) : null
    ));
  }
  companyCurrencyOptions() {
    // Format options according to Semantic UI dropdown
    let currencies = this.props.auth.company.companyCurrency;
    if (!currencies) currencies = [];
    return currencies.map(c => ({
      text: c.code,
      value: c.code,
      content: <Header size="small" content={c.code} subheader={c.name} />,
      // content: `${c.code}  ${c.name}`,
    }));
  }
  showAddBankerAnnouncement = () => {
    const { auth } = this.props;
    return auth.companyBranch.isExternal && !auth.announcementAddBanker;
  }
  fetchNotifications = async (event, nextToken) => {
    event.preventDefault();
    event.stopPropagation();
    const { notifications } = this.state;
    const { t } = this.props;
    let url = '/notifications/';
    if (nextToken) {
      url = `/notifications/?nextToken=${nextToken}`;
    }
    const { data } = this.props.appConfig;
    const { store } = this.context;
    try {
      const response = await serverRequestGet(
        url,
        store,
      );
      await this.setNotificationLoading(false);
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      if (data.notification_counter && data.notification_counter.notifications > 0) {
        // reset unread notification to zero
        data.notification_counter.notifications = 0;
        this.resetNotification();
      }
      let notif = response.data;
      if (notifications.items) {
        notif = notifications;
        notif.items = notifications.items.concat(response.data.items);
        notif.next_token = response.data.next_token;
        if (!response.data.next_token) delete notif.next_token;
      }
      await this.setState({ notifications: notif });
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setNotificationLoading(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
    }
  }
  async resetNotification() {
    const { store } = this.context;
    try {
      await serverRequestPost(
        '/notifications/reset/',
        store,
      );
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }
  setNotificationIcon() {
    const { data } = this.props.appConfig;
    if (data.notification_counter && data.notification_counter.notifications > 0) {
      return (
        <span>
          <Icon name="bell outline" />
          <Label size="tiny" circular color="teal" floating>
            {
              data.notification_counter.notifications > 9 ? '9+' : data.notification_counter.notifications
            }
          </Label>
        </span>
      );
    }
    return (<Icon name="bell outline" />);
  }
  logout = (event) => {
    event.preventDefault();
    const { store } = this.context;
    store.dispatch(logoutAndRedirect());
  }
  togglePopupState = () => {
    const { popUpState } = this.state;
    this.setState({ popUpState: !popUpState });
  }
  toggleVisibility = () => this.setState({ visible: !this.state.visible })
  closeMenu = () => {
    if (this.state.visible) {
      this.setState({ visible: false, activeIndex: 0 });
    }
  }
  checkGroupAccess = (groups) => {
    const teamLeaders = [DEVELOPER_TEAM_LEADER];
    const roles = [
      { text: 'Headquarters', value: '10,6' },
      { text: 'Supervisor', value: '10,11,12,13' },
      { text: 'Sales Manager', value: '10,11,13' },
      { text: 'Sales Admin', value: '10,11' },
      { text: 'Agent Leader', value: '10,17' },
      { text: 'Agency Admin', value: '10,21' },
      { text: '', value: '10' },
    ];
    const rolesArr = [];
    if (groups) {
      if (groups.some(g => g.code === SUPER_ADMIN)) {
        return 'Super Admin';
      }
      if (groups.some(g => g.code === ADMIN_COMMUNITY)) {
        return 'Admin Community';
      }
      if (groups.some(g => g.code === ADMIN)) {
        return 'Admin';
      }
      if (teamLeaders.some(tl => groups.some(g => g.code === tl))) {
        return 'Team Leader';
      }
      groups.forEach((g) => {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      const role = roles.find(g => g.value === String(rolesArr.toString()));
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  }
  hasAccessDE() {
    const { auth, appConfig } = this.props;
    if (auth &&
      auth.companyBranch &&
      !auth.companyBranch.isExternal &&
      appConfig &&
      appConfig.data &&
      appConfig.data.customerOwnedByDeveloperExecutive
    ) {
      return true;
    }
    return false;
  }
  handleOnClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
      this.setState({ ...state });
    }
  }
  modules() {
    const leadv2 = this.props.auth.companyApps.find(ca => ca.appID === LEADV2);
    return [
      {
        name: 'Home',
        route: '/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
      },
      {
        name: 'Projects',
        route: '/projects/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
      },
      {
        name: 'Bookings',
        route: isCountryVietnam(this.props.auth.company.countryCode) ? '/opportunities/' : '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true,
        hideForExternal: isCountryVietnam(this.props.auth.company.countryCode),
      },
      ...(isCountryVietnam(this.props.auth.company.countryCode) ? [{
        name: 'Sales',
        route: '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true,
      }] : []),
      {
        name: 'Customers',
        ...(isCountryVietnam(this.props.auth.company.countryCode) && leadv2 && leadv2.webURL
        ? { link: `${leadv2.webURL.replace(/\/$/, '')}/customers?page=1` }
        : { route: '/customers/' }),
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: this.hasAccessDE() || false,
        isSiteplan: false,
        isSuperAdmin: true,
      },
      {
        name: 'Users',
        route: '/users/',
        enabled: true,
        isBranchLeader: this.props.auth.isBranchLeaderSupervisor || false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
      },
      // {
      //   name: 'Pictures',
      //   route: '/pictures/',
      //   enabled: true,
      // },
      {
        name: 'Help',
        route: 'https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
      },
    ];
  }
  gaEvent = (e, module) => {
    ReactGA.event('BOOK_TOP_MENU', {
      category: 'BOOK_TOP_MENU',
      action: module.route || module.link,
      route: module.route || module.link,
      label: module.name,
      name: module.name,
    });
  };
  getMHubAccountLink = () => {
    const env = config.get('server');
    switch (env) {
      case 'development':
        return 'https://account.stage.mhub.my/ ';
      case 'staging':
        return 'https://account.stage.mhub.my/ ';
      case 'demo':
        return 'https://account.demo.mhub.my/';
      default:
        return 'https://account.mhub.my';
    }
  }

  getResponsiveMenuProperty = (apps, classNames = '', isDropdown = false) => {
    const appsLength = apps.filter(a => a.hasAccess === true).length;
    if (isDropdown) {
      if (appsLength > 5) return { className: `${classNames} large-hide`, only: 'mobile tablet computer', mobile: 6, tablet: 5, computer: 4 };
      if (appsLength > 4) return { className: classNames, only: 'mobile tablet', mobile: 6, tablet: 5 };
      return { className: classNames, only: 'mobile', mobile: 6 };
    }
    if (appsLength > 5) return { className: classNames, only: 'large screen', largeScreen: 13 };
    if (appsLength > 4) return { className: classNames, only: 'computer', computer: 13 };
    return { className: classNames, only: 'tablet computer', tablet: 11, computer: 13 };
  }

  setNotificationLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ notificationLoading: loading }, () => {
        res(loading);
      });
    });
  }

  // Read only at load, never when returning to an existing tab.
  initLanguage = async () => {
    window.history.replaceState({}, '', cleanURL('lang'));
    await initializeDisplayLanguage(
      this.props.i18n,
      normalizeLanguage(this.props.auth.language) || 'en',
      readLanguagePreference,
      () => !this.languageUnmounted,
    );
  }

  parseNotificationData(notif) {
    const parsedNotif = notif;

    try {
      // console.log('notif', notif);
      parsedNotif.data = JSON.parse(notif.data);
      parsedNotif.changes = JSON.parse(notif.changes);
      if (notif.user) {
        parsedNotif.user = JSON.parse(notif.user);
      }
    } catch (e) {
      Bugsnag.notifyException(e);
      return parsedNotif;
    }
    return parsedNotif;
  }

  renderNotificationContent(notif) {
    switch (notif.tpl_action) {
      case 'update_notes':
        return (

          <div className="text-ellipsis">
            {notif.user.name || ''} updated Booking Notes to
              <div className="text-ellipsis" style={{ width: '200px' }}>
                {notif.changes[0].value}
              </div>
            <div style={{ textAlign: 'right' }}>
                at <Timestamp format="YYYY-MM-DD" timestamp={notif.created_at} />
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  filterApps = () => this.state.apps.sort((a, b) => a.order - b.order);

  render() {
    const { auth, t } = this.props;
    const { pathname } = this.props.location;
    const { activeIndex, defaultCurrency, isMobile, popUpState } = this.state;
    const groupAccess = this.checkGroupAccess(this.props.auth.groups);
    const apps = this.filterApps();
    return (
      <div className="main-app">
        <SidebarNav
          visible={this.state.visible}
          onClose={this.closeMenu}
          sidebar={<Sidebar
            as={Menu}
            ref={(ref) => { this.menuBar = ref; }}
            animation="overlay"
            width="thin"
            direction="right"
            visible={this.state.visible}
            icon="labeled"
            vertical
            inverted
            className="side"
          >
            <Menu.Item as="a" className="main" name="user" onClick={this.closeMenu}>
              <Icon name="close" />
            </Menu.Item>
            {defaultCurrency ? (
              <Menu.Item className="sub" name="user">
                <Accordion>
                  <Accordion.Title
                    style={{ color: 'white' }}
                    active={activeIndex === 1}
                    // content={defaultCurrency}
                    index={1}
                    onClick={this.handleOnClick}
                  >
                    <Icon
                      name="dropdown"
                      style={{ marginLeft: '1rem' }}
                    />
                    {defaultCurrency}
                  </Accordion.Title>
                  {this.getCurrencyOptions()}
                </Accordion>
              </Menu.Item>
            ) : null}
            <Menu.Item as={Link} className="sub" to="/profile/" name="user">
              <Icon name="user" />
              {t('Profile')}
            </Menu.Item>
            <Menu.Item as={Link} className="sub" to="https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-" target="_blank" name="user">
              <Icon name="info circle" />
              {t('Help & Support')}
            </Menu.Item>
            <Menu.Item as="a" className="sub" onClick={this.logout} name="user">
              <Icon name="log out" />
              {t('Logout')}
            </Menu.Item>
          </Sidebar>}
        >
          <div className="top-app-menu-wrapper">
            <Container>
              <Grid className="top-app-menu">
                <Grid.Row>
                  <Grid.Column
                    mobile={4}
                    tablet={3}
                    computer={2}
                    className={this.props.auth.company.customLogoSrc === '' ? '' : 'logo_custom_container'}
                  >
                    <NewLogo
                      mhub={!isMobile}
                      customLogoSrc={this.props.auth.company.customLogoSrc}
                    />
                  </Grid.Column>
                  <Grid.Column style={{ paddingTop: '0.45em' }} {...(this.getResponsiveMenuProperty(apps))}>
                    <AppMenu
                      apps={apps}
                      isSiteplan={this.props.auth.isSiteplan}
                    />
                  </Grid.Column>
                  <Grid.Column {...(this.getResponsiveMenuProperty(apps, 'column_book_app_dropdown_menu', true))}>
                    <DropdownMenu
                      apps={apps}
                      isSiteplan={this.props.auth.isSiteplan}
                    />
                  </Grid.Column>
                  <Grid.Column style={isMobile ? { paddingTop: '0.8em', marginRight: '1em' } : { paddingTop: '0.8em' }} mobile={2} tablet={1} computer={1}>
                    <Popup
                      on="click"
                      open={popUpState}
                      onOpen={this.togglePopupState}
                      onClose={this.togglePopupState}
                      trigger={<img alt="top-menu-user" src="/assets/images/icons/User.svg" style={{ width: '3em', height: '2em', cursor: 'pointer' }} />}
                    >
                      <Grid className="top-popup-menu">
                        <Grid.Row style={{ borderBottom: '1px solid #DBDDDE', background: '#F8F8F8' }}>
                          <Grid.Column>
                            <b>{this.props.auth.preferredName}</b>
                          </Grid.Column>
                        </Grid.Row>
                        <Link
                          as="a"
                          to="/profile/"
                          className="row popup-row"
                          onClick={this.togglePopupState}
                        >
                          <Grid.Column className="popup-col">
                            <Grid.Row>
                              <Grid.Column>
                                <img alt="top-menu-user" src="/assets/images/icons/User.svg" style={{ width: '3em', height: '2em', cursor: 'pointer' }} />
                              </Grid.Column>
                              <Grid.Column>
                                {t('My Profile')}
                              </Grid.Column>
                            </Grid.Row>
                          </Grid.Column>
                        </Link>
                        {this.props.auth && (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) ? (
                          <Link
                            as="a"
                            to={this.getMHubAccountLink()}
                            className="row popup-row"
                            target="_blank"
                          >
                            <Grid.Column className="popup-col">
                              <Grid.Row>
                                <Grid.Column>
                                  <img alt="top-menu-user" src="/assets/images/icons/accountSVG.svg" style={{ width: '3em', height: '2em', cursor: 'pointer' }} />
                                </Grid.Column>
                                <Grid.Column>
                                  {t('MHub account')}
                                </Grid.Column>
                              </Grid.Row>
                            </Grid.Column>
                          </Link>
                      ) : null}
                        <Link
                          onClick={this.logout}
                          className="row popup-row"
                          data-bot-target="signout"
                        >
                          <Grid.Column className="popup-col">
                            <Grid.Row>
                              <Grid.Column>
                                <img alt="top-menu-user" src="/assets/images/icons/LogoutSVG.svg" style={{ width: '3em', height: '2em', cursor: 'pointer' }} />
                              </Grid.Column>
                              <Grid.Column>
                                {t('Sign out')}
                              </Grid.Column>
                            </Grid.Row>
                          </Grid.Column>
                        </Link>
                      </Grid>
                    </Popup>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div><div className="app-menu-wrapper">
            <div className="app-menu-wrap">
              <Container>
                <Grid className="middle-app-menu">
                  <Grid.Row>
                    <Grid.Column tablet={13} computer={13}>
                      <div className="app-menu-details">
                        <div className="details" style={{ alignSelf: 'normal' }}>
                          <div className="item">
                            <div>
                              <h2>
                                {this.props.auth.preferredName}
                              </h2>
                            </div>
                            {groupAccess ?
                              <div>
                                <Label size="tiny">{t(groupAccess, { ns: TRANSLATION_FILES.constants })}</Label>
                              </div> :
                            null}
                          </div>
                          <div className="item">
                            <h5>
                              {this.props.auth.companyBranch.shortName} | <span className="company_shortname">{this.props.auth.company.shortName}</span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </Grid.Column>
                    <Grid.Column style={{ textAlign: 'right' }} only="tablet computer" tablet={3} computer={3} className="app-menu-options">
                      {
                      // Make sure default currency is set before render dropdown
                      !isForeignCompany(auth.company) && (
                        <LanguageSwitcher />
                      )}
                      {
                        auth.company && isForeignCompany(auth.company) && (
                          <LanguageSwitcher />
                        )
                      }
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Menu
                  className="app-menu"
                  pointing
                  secondary
                >
                  <Menu.Menu>
                    {this.modules()
                    .filter((module) => {
                      const companyBranch = this.props.auth.companyBranch;
                      if (companyBranch && companyBranch.isExternal && module.hideForExternal) {
                        return false;
                      }
                      if (this.props.auth.isSuperAdmin) {
                        return module.isSuperAdmin;
                      }
                      if (this.props.auth.isHeadquarters) {
                        return module.isHeadquarters;
                      }
                      if (this.props.auth.isBranchLeader) {
                        return module.isBranchLeader;
                      }
                      if (this.props.auth.isDeveloper) {
                        return module.isDeveloper;
                      }
                      if (this.props.auth.isSiteplan) {
                        return module.isSiteplan;
                      }
                      return true;
                    })
                    .map((module, idx) => (
                      <Menu.Item
                        className="top-menu"
                        key={idx}
                        as={Link}
                        name={module.name !== 'Help' || (module.name === 'Help' && !isMobile) ? t(module.name) : ''}
                        content={module.name !== 'Help' || (module.name === 'Help' && !isMobile) ? t(module.name) : ''}
                        disabled={!module.enabled}
                        active={module.route === '/' ?
                          pathname === module.route : pathname.startsWith(module.route)}
                        to={module.link ? '' : module.route}
                        href={module.link && module.link}
                        onClick={e => this.gaEvent(e, module)}
                        icon={module.name === 'Help' && isMobile ? 'info circle' : null}
                        target={module.name === 'Help' || module.name === 'Marketplace' ? '_blank' : null}
                      />
                    ))}
                  </Menu.Menu>
                </Menu>
              </Container>
              <div className="header-cover" />
            </div>
          </div><div className="app-content">
            {this.props.children}
          </div><AppFooter />
        </SidebarNav>
        <Flash />
        <ChangesPrompt />
        {isCountryVietnam(this.props.auth.company.countryCode) ?
          null
        : <AddBankerAnnouncement show={this.showAddBankerAnnouncement()} />}
      </div>
    );
  }
}

BookApp.propTypes = {
  children: PropTypes.node,
};

BookApp.contextTypes = {
  store: PropTypes.object,
};

export default withTranslation(namespaces)(connect(BookApp.mapStateToProps)(BookApp));



// WEBPACK FOOTER //
// ./src/containers/BookApp.jsx